import React from 'react';
import { Alert, Button, Modal, Spin } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { downloadMassiveErrors } from 'services/MassiveService';
import { useMassiveErrors } from 'queries/useMassiveQuery';
import MassiveErrorsTable from './errorsTable';
import MassiveServiceError from './serviceError';
import { downloadOrNotify } from './download';

interface Props {
  open: boolean;
  massiveId?: string;
  onClose: () => void;
}

const MassiveErrorsModal = ({ open, massiveId, onClose }: Props) => {
  const { data, isFetching, isError, error, refetch } = useMassiveErrors(
    open ? massiveId : undefined,
  );

  return (
    <Modal
      open={open}
      width={820}
      title={`Filas rechazadas de ${massiveId ?? ''}`}
      onCancel={onClose}
      footer={[
        <Button
          key="download"
          icon={<DownloadOutlined />}
          disabled={!data?.length}
          onClick={() =>
            downloadOrNotify(
              () => downloadMassiveErrors(massiveId as string),
              `${massiveId}-rechazadas.xlsx`,
            )
          }
        >
          Descargar rechazadas (.xlsx)
        </Button>,
        <Button key="close" type="primary" onClick={onClose}>
          Cerrar
        </Button>,
      ]}
    >
      {isError ? (
        <MassiveServiceError
          error={error}
          title="No se pudieron cargar las filas rechazadas"
          onRetry={() => refetch()}
        />
      ) : null}
      {isFetching ? <Spin /> : null}
      {!isFetching && !isError && !data?.length ? (
        <Alert
          type="success"
          showIcon
          message="No hay filas rechazadas en esta masiva"
        />
      ) : null}
      {!isFetching && data?.length ? (
        <>
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 12 }}
            message="El Excel trae sólo estas filas"
            description="Corregilas y volvé a subir ese mismo archivo: como las creadas no están ahí, no se duplica nada."
          />
          <MassiveErrorsTable rows={data} />
        </>
      ) : null}
    </Modal>
  );
};

export default MassiveErrorsModal;
